import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Button from '@/src/shared/components/Button';
import { bp, colors } from '@/styles';

// import style from './Accordion.scss';
const style = {
  panelContent: css`
    display: flex;
    @media ${bp.md} {
      margin-left: 85px;
    }
    .anticon {
      font-size: 5.6rem;
      color: ${colors.secondaryBlue};
      display: none;
      @media ${bp.sm} {
        display: block;
      }
    }
  `,
  panelInner: css`
    max-width: 560px;
    @media ${bp.sm} {
      margin-left: 32px;
    }
  `,
  panelTitle: css`
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    font-weight: 900;
    line-height: 2.8rem;
  `,
  panelMeta: css`
    display: flex;
    color: ${colors.secondaryGray};
    font-size: 1.2rem;
    font-weight: 900;
    line-height: 2rem;
    span {
      display: flex;
      align-items: center;
      &::after {
        display: block;
        background-color: ${colors.secondaryGray};
        content: '';
        height: 1em;
        width: 1px;
        margin: 0 4px;
      }
      &:last-child::after {
        display: none;
      }
    }
  `,
  panelDescription: css`
    font-size: 1.6rem;
    line-height: 2.8rem;
    margin-bottom: 0;
  `,
};

// this is the character limit which will determine if the description is truncated
const descriptionTopLimit = 115;

const DigestPanelContent = ({ icon, title, meta, description }) => {
  const [shown, setShown] = useState(false);

  // shorten the description if it's too long
  const cutdesc =
    description.length > descriptionTopLimit
      ? `${description.substring(0, descriptionTopLimit)}...`
      : null;

  const more = (
    <Button onClick={() => setShown(!shown)} theme="link">
      {shown ? `« Less` : 'More »'}
    </Button>
  );

  // shows the descriptionTopLimit char description with ... when description exceeds descriptionTopLimit chars
  // and show button hasn't been toggled true
  const formattedDescription = (() => {
    if (!cutdesc) return description;
    return (
      <span>
        {shown ? description : cutdesc}
        {more}
      </span>
    );
  })();

  return (
    <div css={style.panelContent}>
      {icon}
      <div css={style.panelInner}>
        <h4 css={style.panelTitle}>{title}</h4>
        <div css={style.panelMeta}>
          {meta.map(m => (
            <span key={m}>{m}</span>
          ))}
        </div>
        <p css={style.paneldescription}>{formattedDescription}</p>
      </div>
    </div>
  );
};

DigestPanelContent.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  meta: PropTypes.array,
  description: PropTypes.string,
};

DigestPanelContent.defaultProps = {
  icon: null,
  title: '',
  meta: [],
  description: '',
};

export default DigestPanelContent;
